import gettext from '@sdk/lang/gettext';

export const TIMESHEETS_TABLE_COLUMN_DESCRIPTIONS = {
  date: gettext('Date'),
  fullLegalName: gettext('Legal name'),
  employee: gettext('Employee name'),
  employeeId: gettext('Employee ID'),
  location: gettext('Locations'),
  position: gettext('Positions'),
  groups: gettext('Groups'),
  tags: gettext('Tags'),
  clockedIn: gettext('Clock in time'),
  clockedOut: gettext('Clock out time'),
  actual: gettext('Shift duration'),
  scheduled: gettext('Scheduled shift duration'),
  difference: gettext('Difference'),
  dtstart: gettext('Scheduled shift start'),
  dtend: gettext('Scheduled shift end'),
  status: gettext('Status'),
  clockInDistanceFromLocation: gettext('Clock in distance'),
  clockOutDistanceFromLocation: gettext('Clock out distance'),
  source: gettext('Source'),
  scheduledBreakDuration: gettext('Scheduled break duration'),
  break: gettext('Break duration'),
  breakStart: gettext('Break start'),
  breakEnd: gettext('Break end'),
  breakType: gettext('Break type'),
  isAutoClockOut: gettext('Auto clock-out'),
};

export const TIMESHEETS_TABLE_COLUMN_HEADERS = {
  date: gettext('date'),
  fullLegalName: gettext('Legal name'),
  employee: gettext('employee'),
  name: gettext('employee'),
  employeeId: gettext('employee id'),
  location: gettext('locations'),
  position: gettext('positions'),
  groups: gettext('groups'),
  tags: gettext('tags'),
  clockedIn: gettext('clock in\ntime'),
  clockedOut: gettext('clock out\ntime'),
  actual: gettext('shift\nduration'),
  scheduled: gettext('sch. shift\nduration'),
  difference: gettext('difference'),
  dtstart: gettext('sch.\nshift start'),
  dtend: gettext('sch.\nshift end'),
  status: gettext('status'),
  assigneeNotes: gettext('notes'),
  clockInDistanceFromLocation: gettext('clock in\ndist.'),
  clockOutDistanceFromLocation: gettext('clock out\ndist.'),
  source: gettext('Source'),
  scheduledBreakDuration: gettext('Sch. break\nduration'),
  break: gettext('break\nduration'),
  breakStart: gettext('Break\nstart'),
  breakEnd: gettext('Break\nend'),
  breakType: gettext('Break type'),
  isAutoClockOut: gettext('Auto\nclock-out'),
};

export const DEFAULT_INTERVAL_IN_MINUTES_FOR_TIME_PICKERS = 10;
